import Api from '../../services/Api';

const getDepartamentoProduto = (idDepartamento, params) => {
    const url = `/gestao/departamento/${idDepartamento}/produto`;

    return Api.get(url, { params });
};

const changeProdutoDisponibilidade = async (itens, tpDisponivel) => {
    const body = {
        tpDisponivel,
        itens
    };

    const request = await Api.put('/gestao/produto-disponibilidade', body),
        response = request.data;

    return response;
};

export { getDepartamentoProduto, changeProdutoDisponibilidade };
